import { authHeader } from '../../_helpers';
import axios from 'axios';

export const userListDataSevice = {
    userListData,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


function userListData(data) {
    return axios.post(`/analytics/participant/list/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/userList.service.js